// ## Labels
export const CONFERENCE_NAME = 'Wilderness Ways';
export const EMAIL_ADDRESS = 'no-reply@wildernessways.com';
export const DISCOUNT_CODE = '43qj7';
export const EMAIL_BANNER = 'Wilderness Ways, San Francisco. September 25-28.';




// WEBPACK FOOTER //
// ./src/constants.js